import { useEffect } from "react";

/** Tiny redirect to the standalone "Academia B2B" course HTML. */
const CursoAcademiaB2BRedirect = () => {
  useEffect(() => {
    window.location.replace("/cursoacademiab2b.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0D1B2A",
      color: "#C9A84C",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando curso…
    </div>
  );
};

export default CursoAcademiaB2BRedirect;
